import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgVisibilityPublic = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.9999 8.33371C11.9999 9.56102 11.0049 10.556 9.77761 10.556C9.47435 10.556 9.18527 10.4952 8.92188 10.3852C8.75735 10.7798 8.66649 11.2128 8.66649 11.6671C8.66649 13.508 10.1589 15.0004 11.9999 15.0004C13.8408 15.0004 15.3332 13.508 15.3332 11.6671C15.3332 9.82611 13.8408 8.33371 11.9999 8.33371Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9983 5C9.19301 5 6.94666 6.09525 5.31137 7.39883C3.6865 8.69051 2.59978 10.2381 2.08593 11.3006C1.97136 11.5358 1.97136 11.7977 2.08593 12.0328C2.59978 13.0953 3.6865 14.6429 5.31137 15.9346C6.94666 17.2382 9.19301 18.3334 11.9983 18.3334C14.8037 18.3334 17.05 17.2382 18.6853 15.9346C20.3102 14.64 21.3969 13.0953 21.9142 12.0328C22.0288 11.7977 22.0288 11.5358 21.9142 11.3006C21.3969 10.2381 20.3102 8.69051 18.6853 7.39883C17.05 6.09525 14.8037 5 11.9983 5ZM17.5557 11.6667C17.5557 14.1213 15.0684 16.1112 12.0001 16.1112C8.93181 16.1112 6.44448 14.1213 6.44448 11.6667C6.44448 9.2121 8.93181 7.22224 12.0001 7.22224C15.0684 7.22224 17.5557 9.2121 17.5557 11.6667Z", fill: props.fill }));
});
export default SvgVisibilityPublic;
